import { render, staticRenderFns } from "./ClientAreaPage.vue?vue&type=template&id=d6b1408c"
import script from "./ClientAreaPage.vue?vue&type=script&lang=js"
export * from "./ClientAreaPage.vue?vue&type=script&lang=js"
import style0 from "./ClientAreaPage.vue?vue&type=style&index=0&id=d6b1408c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports